export default {
  'global.button.viewAll': 'Ver todas',
  'global.button.viewAll1': 'Ver todos',
  'global.button.cancel': 'Cancelar',
  'global.button.close': 'Cerrar',
  'global.button.add1': 'Adicionar',
  'global.button.add': 'Agregar',
  'global.button.save': 'Guardar',
  'global.button.confirm': 'Confirmar',
  'global.button.delete': 'Eliminar',
  'global.button.edit': 'Editar',
  'global.button.test': 'Probar',
  'global.button.publish': 'Publicar',
  'global.button.continues': 'Continuar',
  'global.button.reject': 'Rechazar',
  'global.button.detail': 'Detalles',
  'global.button.delegatedTask': 'Tareas Delegadas',
  'global.button.approved': 'Aprobar',
  'global.button.complete': 'Completar',
  'global.button.execution': 'Ejecutada',
  'global.button.signature': 'Firmar',
  'global.button.send': 'Enviar',
  'global.button.toLogin': 'Ir al login',
  'global.button.toHome': 'Ir al Inicio',
  'global.button.enter': 'Acceder',
  'global.button.ms365': 'Microsoft 365',
  'global.button.rememberMe': 'Recordar',
  'global.button.copy': 'Copiar',
  'global.button.reset.password': 'Crear nueva contraseña',
  'global.button.sendCode': 'Enviar Código',
  'global.button.addForm': 'Crear Formulario',
  'global.button.export': 'Exportar',
  'global.button.import': 'Importar',
  'global.button.createRequest': 'Crear Solicitud',
  'global.button.viewDetails': 'Ver Detalles',
  'global.button.cancelRequest': 'Cancelar Solicitud',
  'global.button.completeRequestInformation': 'Completar Información de Solicitud',
  'global.button.approveRequest': 'Aprobar Solicitud',
  'global.button.executeTask': 'Ejecutar Tarea',
  'global.button.signDocument': 'Firmar Documento',
  'global.button.reassignTask': 'Reasignar Tarea',
  'global.button.massRequestApprove': 'Aprobar Solicitudes',
  'global.button.massRequestReject': 'Rechazar Solicitudes',
  'global.button.initApplication': 'Iniciar Solicitud',
  'global.button.erase': 'Limpiar',
  'global.button.undo': 'Deshacer',
  'global.button.redo': 'Rehacer',
  'global.text.radius.brush': 'Radio del puntero',
  'global.button.approve': 'Aprobar',
  'global.button.toFilter': 'Filtrar',
  'global.button.apply': 'Aplicar',
  'global.button.resetFilters': 'Limpiar Filtros',
  'global.button.no': 'No',
  'global.button.yes': 'Sí',
  'global.button.signIn': 'Iniciar sesión',
  'global.button.cleanup': 'Borrar',
  'global.button.download': 'Descargar',
  'global.button.print': 'Imprimir',
  'global.button.next': 'Siguiente',
  'global.button.previous': 'Atrás',
  'global.button.google': 'Google',
  'global.button.backInAutomy': 'Ingresar a',
  'global.button.saveAndComplete': 'Completar',
  'global.button.extraFields': 'Campos extras',
  'global.button.sendAccountConfirmationEmail': 'Confirmación de Cuenta',
  'global.button.confirmAccount': 'Confirmar Cuenta',
  'global.button.sendPasswordRecoveryEmail': 'Recuperar Contraseña',
  'global.button.resetPassword': 'Restablecer Contraseña',
  'global.button.unlockAccount': 'Desbloquear Cuenta',
  'global.button.generate': 'Generar',
  'global.button.retry': 'Rententar',
  'global.button.import': 'Importar',
  'global.button.export': 'Exportar',
  'global.button.purge': 'Borrar Datos',
  'global.restore.confirmQuestion': '¿Deseas restaurarlo?',
  'global.restore.restoreButton': 'Restaurar',
  // Canvas actions
  'action.config.beautify': 'Embellecer',
  'action.canvas.fit': 'Ajustar',
  'action.canvas.center': 'Centrar',
  'action.canvas.reset': 'Restablecer',
  'action.canvas.zoomIn': 'Acercar',
  'action.canvas.zoomOut': 'Alejar',
  'action.canvas.addNote': 'Agregar Nota',
  'action.canvas.fullscreen': 'Pantalla completa',
  'action.canvas.exitFullscreen': 'Salir de pantalla completa',
  'action.generate.ai.coming.soon': 'Genera AI (próximamente)',
  'global.button.loadExcel': 'Cargar Excel',
  'global.button.addGroup': 'Agregar Grupo',
  'global.button.removeCondition': 'Eliminar Condición',
  'global.button.company': 'Cambiar Empresa',
  'global.button.environment': 'Cambiar Entorno',
  'global.button.moreDetail': 'Mas Detalles',
  'global.button.lessDetail': 'Menos Detalles',
  'global.text.contentTooLarge':
    'El contenido es demasiado grande para mostrarse. Por favor, descárguelo para verlo.',
  'global.button.pin': 'Enviar PIN de Aprobación',
  'global.button.myDay.add': 'Agregar a Mi día',
  'global.button.mark.important': 'Marcar como Importante',
  'global.button.mark.completed': 'Marcar como Completada',
  'global.button.info': 'Información',
  'global.button.move': 'Mover a...',
  'global.button.delete': 'Eliminar',
  'global.button.create.list': 'Crear Lista',
  'global.button.accountConfirm': 'Confirmar Cuenta',
  'global.button.create': 'Crear',
  'global.button.create.task': 'Crear Tarea',
  'global.button.accountConfirm': 'Confirmar Cuenta',
  'global.button.details': 'Detalles',
  'global.button.editGridMode': 'Editar',
  'global.button.exitGridMode': 'Salir Modo Edición',
  'global.button.data': 'Datos',

  'global.status.sent': 'Enviadas',
  'global.status.sent1': 'Enviada',
  'global.status.received': 'Recibidas',
  'global.status.received1': 'Recibida',
  'global.status.pending': 'Pendientes',
  'global.status.pending1': 'Pendiente',
  'global.status.running': 'En ejecución',
  'global.status.canceled': 'Canceladas',
  'global.status.canceled1': 'Cancelada',
  'global.status.approved': 'Aprobadas',
  'global.status.approved1': 'Aprobada',
  'global.status.rejected': 'Rechazadas',
  'global.status.rejected1': 'Rechazada',
  'global.status.voided': 'Anuladas',
  'global.status.voided1': 'Anulada',
  'global.status.required': 'Requerido',
  'global.status.noRequired': 'No Requerido',
  'global.status.execution': 'Ejecución',
  'global.status.error': 'Error',
  'global.status.processing': 'Procesando',
  'global.status.processed': 'Procesado',
  'global.status.processingTaskItems': 'Procesando Tareas',

  'global.text.agent': 'Agente IA',
  'global.copyright': 'Todos los derechos reservados',
  'global.text.copyright': 'Copyright',
  'global.text.add': 'Agregar',
  'global.text.remove': 'Eliminar',
  'global.text.update': 'Actualizar',
  'global.text.activate': 'Activar',
  'global.text.detail': 'Detalle',
  'global.text.detail1': 'Detalles',
  'global.text.summary': 'Resumen',
  'global.text.events': 'Eventos',
  'global.text.eventHistory': 'Historial de eventos',
  'global.text.application': 'Solicitud',
  'global.text.completed': 'Completada',
  'global.text.edit': 'Editar',
  'global.text.cancel': 'Cancelar',
  'global.text.processes': 'Procesos',
  'global.text.groups': 'Grupos',
  'global.text.items': 'Elementos',
  'global.text.entities': 'Entidades',
  'global.text.premiumEntities': 'Entidades Premium',
  'global.text.premium': 'Premium',
  'global.text.basic': 'Básica',
  'global.text.showList': 'Mostrar Lista',
  'global.text.viewReport': 'Ver Reporte',
  'global.text.favorites': 'Favoritos',
  'global.text.list': 'Lista',
  'global.text.lists': 'Listas',
  'global.text.report': 'Reporte',
  'global.text.reports': 'Reportes',
  'global.text.adminReports': 'Sistema',
  'global.text.group': 'Grupo',
  'global.text.all': 'Todos',
  'global.text.all1': 'Todas',
  'global.text.advancedFilter': 'Filtro avanzado',
  'global.text.hideFilter': 'Ocultar filtro',
  'global.text.search': 'Buscar',
  'global.text.filters': 'Filtros',
  'global.text.date': 'Fecha',
  'global.text.createdDate': 'Fecha de Creación',
  'global.smsDeliveryProvider.twilio': 'Twilio',
  'global.smsDeliveryProvider.sendblue': 'Sendblue',
  'global.text.updatedDate': 'Fecha de Actualización',
  'global.text.isPublic': '¿Público?',
  'global.text.user': 'Usuario',
  'global.text.system': 'Sistema',
  'global.text.users': 'Usuarios',
  'global.text.url': 'dirección url',
  'global.text.headers': 'Cabeceras',
  'global.text.key': 'Llave',
  'global.text.value': 'Valor',
  'global.text.host': 'Host',
  'global.text.port': 'Puerto',
  'global.text.position': 'Puesto',
  'global.text.userGroup': 'Grupo de Usuarios',
  'global.text.config': 'Configurar',
  'global.text.processConfig': 'Configurar',
  'global.text.restricted': 'Restringido',
  'global.text.public': 'Público',
  'global.text.permissions': 'Permisos',
  'global.text.menu': 'Menú',
  'global.text.validated': 'Validada',
  'global.text.notValidated': 'No Validada',
  'global.text.published': 'Publicada',
  'global.text.draft': 'Borrador',
  'global.text.server': 'Servidor',
  'global.text.byPosition': 'Por puesto',
  'global.text.byUser': 'Por Usuario',
  'global.text.byGroups': 'Por grupos',
  'global.text.byGroup': 'Por grupo',
  'global.text.userExit': 'Usuario existe',
  'global.text.positionExit': 'Puesto existe',
  'global.text.userGroupExit': 'Grupo de usuario existe',
  'global.text.token': 'Token',
  'global.text.apiKeySecret': 'Clave API Secreta',
  'global.text.fromPhoneNumber': 'Número de teléfono de origen',
  'global.text.process': 'Proceso',
  'global.text.web': 'Web',
  'global.text.mobile': 'Móvil',
  'global.text.webMobile': 'Web & Móvil',
  'global.text.action': 'Acción',
  'global.text.showBy': 'Mostrar por',
  'global.text.operation': 'Operación',
  'global.text.observation': 'Observación',
  'global.text.administrator': 'Administrador',
  'global.text.superAdministrator': 'Super Administrador',
  'global.text.copying': 'Copiado',
  'global.text.network.title': 'Excepción de red',
  'global.text.network.info': `No se pudo establecer conexión con el servidor. Por favor, verifique su conexión a internet e inténtelo nuevamente.`,
  'global.text.timeout.title': 'Solicitud Expirada',
  'global.text.timeout.info':
    'La solicitud ha tardado demasiado tiempo. Por favor, intente nuevamente.',
  'global.text.cors.title': 'Acceso Restringido',
  'global.text.cors.info':
    'No se pudo completar la operación debido a un problema al comunicarse con el servidor. Esto puede deberse a restricciones de seguridad del navegador o a la configuración de la red. Si el problema persiste, por favor contacte a soporte.',
  'global.text.loading': 'cargando',
  'global.text.providers': 'Proveedores',
  'global.text.verifyCode': 'Código de Verificación',
  'global.text.allowedFileFormats': 'Formatos',
  'global.text.startProcess': 'Iniciar',
  'global.text.reassignTask': 'Reasignar Tarea',
  'global.text.site': 'Portales',
  'global.text.app': 'AUTOMY',
  'global.text.start': 'Iniciar',
  'global.text.scheduled': 'Programado',
  'global.text.automated': 'Automatizado',
  'global.text.viewDetail': 'Ver detalle',
  'global.text.delete': 'Eliminar',
  'global.text.mode': 'Modo',
  'global.text.table': 'Tabla',
  'global.text.property': 'Propiedad',
  'global.text.loadingFiles': 'Cargando archivos',
  'global.text.fallback.location': 'ubicación Actual',
  'global.text.fileName': 'Nombre de Archivo',
  'global.text.pageSize': '{num} registros',
  'global.text.fields': 'Campos',
  'global.text.appClient': 'Aplicación Cliente',
  'global.text.selectedElements': 'Tienes {count} {elements} seleccionados',
  'global.text.elementSelected': 'elemento',
  'global.text.elementsSelected': 'elementos',
  'global.text.selectAll': 'Seleccionar todo',
  'global.text.engineVersion': 'Versión del Motor',
  'global.text.resource': 'Tipo de Recurso',
  'global.text.initBy': 'Iniciado Por',
  'global.text.orderBy': 'Ordenar',
  'global.text.entity': 'Entidad',
  'global.text.response': 'Respuesta',
  'global.text.operation': 'Operación',
  'global.text.dates': 'Fechas',
  'global.text.description': 'Descripción',
  'global.text.sp_call': 'Llamada SP',
  'global.text.order': 'Orden',
  'global.text.title': 'Título',
  'global.text.name': 'Nombre',
  'global.text.details': 'Detalles',
  'global.text.editor': 'Editor',
  'global.text.loading': 'Cargando',
  'global.text.isActive': 'Habilitado',
  'global.text.favorite': 'Favorito',
  'global.text.diagram': 'Diagrama',

  'global.text.english': 'Inglés',
  'global.text.spanish': 'Espańol',
  'global.text.language': 'Idioma',

  'global.text.context.company': 'Empresas',
  'global.text.context.environment': 'Entornos',
  'global.text.context.user': 'Mi Perfil',
  'global.text.context.site': 'Portales',

  'global.text.plan': 'Plan',
  'global.text.partner': 'Socio',
  'global.text.commercialName': 'Nombre Comercial',
  'global.text.noIdentity': 'Nro. Identidad',
  'global.text.country': 'País',
  'global.text.roles': 'Roles',
  'global.text.channel': 'Canal',
  'global.text.distributor': 'Distribuidor',
  'global.text.reseller': 'Revendedor',

  'company.subscription.status.active': 'Activa',
  'company.subscription.status.pending-activation': 'Pendiente de activación',
  'company.subscription.status.pending-payment': 'Pendiente de pago',
  'company.subscription.status.past-due': 'Pago vencido',
  'company.subscription.status.suspended': 'Suspendida',
  'company.subscription.status.canceled': 'Cancelada',

  'company.channel.actor.none': 'Sin canal',
  'company.channel.actor.automy-internal': 'Interno Automy',
  'company.channel.actor.operator': 'Operador',
  'company.channel.actor.distributor': 'Distribuidor',
  'company.channel.actor.partner': 'Socio',
  'company.channel.actor.reseller': 'Revendedor',
  'company.channel.actor.customer': 'Cliente',

  'company.role.owner': 'Propietario',
  'company.role.admin': 'Administrador',
  'company.role.billing-admin': 'Admin. Facturación',
  'company.role.commercial-admin': 'Admin. Comercial',
  'company.role.user-admin': 'Admin. Usuarios',
  'company.role.support': 'Soporte',
  'company.role.auditor': 'Auditor',
  'company.role.collaborator': 'Colaborador',
  'company.role.user': 'Usuario',
  'company.role.super-admin': 'Super Admin',

  'company.plan.tag.custom': 'Custom',
  'company.plan.tag.exclusive': 'Exclusivo',
  'company.plan.tag.internal': 'Interno',

  'global.text.upload.camera': 'Tomar una Foto',
  'global.text.upload.image': 'Arrastra y suelta una Imagen aquí o haz clic',
  'global.text.upload.file': 'Arrastre y Suelte un Archivo aquí o haga Clic',
  'global.text.upload.document': 'Arrastre y Suelte un Documento aquí o haga Clic',
  'global.text.upload.format.error':
    'Formato de archivo inválido. Por favor suba un archivo de Excel (.xlsx o .xls)',
  'global.text.upload.files': 'Arrastre y Suelte uno o múltiples archivos aquí o haga Clic',
  'global.text.validate': 'Validar',

  'global.text.preview': 'Visualizar',
  'global.text.expand': 'Expandir',

  'vectorsUploader.subtitle.empty': 'Documentos para entrenar al agente',
  'vectorsUploader.subtitle.count': '{count} documentos · {size}',
  'vectorsUploader.action.add': 'Agregar documentos',
  'vectorsUploader.action.removeSelected': 'Eliminar {count} seleccionados',
  'vectorsUploader.search.placeholder': 'Filtrar documentos',
  'vectorsUploader.search.empty': 'Ningún documento coincide con "{q}"',
  'vectorsUploader.selection.selectAll': 'Seleccionar todos',
  'vectorsUploader.selection.summary': '{count} seleccionados',
  'vectorsUploader.empty.title': 'Sin documentos de entrenamiento',
  'vectorsUploader.empty.hint':
    'Agrega documentos para que el agente los use como base de conocimiento',
  'vectorsUploader.drop.title': 'Suelta los archivos aquí',
  'vectorsUploader.status.indexed': 'Indexado',
  'vectorsUploader.status.uploading': 'Subiendo',
  'vectorsUploader.status.uploadingPct': 'Subiendo · {pct}%',
  'vectorsUploader.status.error': 'Error',
  'global.text.editExpanded': 'Editar Expandido',
  'global.text.server': 'Servidor',
  'global.created.asc': 'Fecha Asc',
  'global.created.desc': 'Fecha Desc',
  'global.text.order.short.asc': 'Creación Asc',
  'global.text.order.short.desc': 'Creación Desc',

  'global.text.asc': 'Asc',
  'global.text.desc': 'Desc',

  'global.empty': 'No hay información para mostrar',
  'global.empty.processes': 'No tienes procesos que gestionar',
  'global.empty.source': 'Aún no has ingresado información para mostrar',
  'global.empty.pendingTasks': '¡Felicidades, no tienes tareas pendientes!',

  'global.paged.item5': '5 registros',
  'global.paged.items10': '10 registros',

  'global.status.active': 'Activos',
  'global.status.inactive': 'Inactivos',

  'global.tooltip.userGroup': 'Grupo de Usuarios',
  'global.tooltip.userEnviroment': 'Entornos de Usuario',

  'global.enable': 'Habilitar',
  'global.disable': 'Deshabilitar',
  'global.name': 'Nombre',
  'global.description': 'Descripción',
  'global.category': 'Categoría',
  'global.email': 'Correo',

  'global.method': 'Método',
  'global.parameters': 'Parametros',
  'global.position': 'Posición',
  'global.noData': 'Sin datos',
  'global.authorizationType': 'Tipo de Authorización',
  'global.enabledElement': '¿Elemento Habilitado?',
  'global.default': 'Predeterminado',
  'global.emailAddress': 'Correo Electrónico',
  'global.password': 'Contraseña',
  'global.confirmPassword': 'Confirmar Contraseña',
  'global.order': 'Orden',
  'global.executionOrder': 'Orden de Ejecución',
  'global.isPublic': '¿Es Pública?',

  'global.uploadFile': 'Arrastre y Suelte un Archivo aquí o haga Clic',
  'global.enablePin': 'Habilitar PIN',
  'global.pinCode': 'Código PIN',
  'global.reportType': 'Tipo de Reporte',
  'global.tags': 'Etiquetas',
  'global.platform': 'Plataforma',

  'global.user': 'Usuario',
  'global.system': 'Sistema',
  'global.key': 'Llave',
  'global.value': 'Valor',
  'global.type': 'Tipo',
  'global.title': 'Título',
  'global.databaseType': 'Tipo de Base de Datos',

  'global.role': 'Rol',
  'global.show': 'Mostrar',
  'global.created': 'Fecha de Creación',
  'global.updated': 'Fecha de Actualización',
  'global.userCreator': 'Usuario creador',
  'global.userModifier': 'Usuario actualizador',

  'global.of': 'de',
  'global.add': 'Agregar',

  'process.text.fileName': 'Nombre',
  'process.text.userCreator': 'Autor',
  'process.text.contentType': 'Tipo de Archivo',
  'process.text.options': 'Opciones',

  'global.text.status': 'Estado',
  'global.text.processGroup': 'Grupo Procesos',
  'global.text.receivedRequests': 'Solicitudes Recibidas',
  'global.text.myRequests': 'Mis Solicitudes',
  'global.text.requestOrigin': 'Origen',

  'global.text.queries': 'Consultas',
  'global.text.query': 'Consulta',
  'global.text.database': 'Base de Datos',

  'global.text.approved': 'Aprobado',
  'global.text.rejected': 'Rechazado',
  'global.text.signed': 'Firmado',
  'global.text.taskExecuted': 'Tarea Ejecutada',
  'global.text.saved': 'Guardada',
  'global.text.savedAndCompleted': 'Guardada y Completada',

  'global.text.processApprovalEvaluation': 'Proceso Aprobación Evaluación',
  'global.text.delegation': 'Delegación',
  'global.text.delegationRestored': 'Delegación Reasignada',
  'global.text.reassignedTask': 'Tarea Reasignada',
  'global.text.selfAssignedTask': 'Tarea Auto-asignada',

  'global.text.enabled': 'Habilitado',
  'global.text.disabled': 'Deshabilitado',
  'global.text.yes': 'Si',
  'global.text.no': 'No',
  'global.text.administrador': 'Administrador',
  'global.defaults': 'Predeterminados',
  'global.notDefaults': 'No Predeterminados',
  'global.text.criteria': 'Criterios',
  'global.text.note': 'Nota',
  'global.text.none': 'Ninguna',
  'global.text.minute': 'Minutos',
  'global.text.hour': 'Horas',
  'global.text.day': 'Días',
  'global.text.month': 'Mes',
  'global.title.addedUsers': 'Usuarios Agregados',
  'global.text.form': 'Formulario',
  'global.text.byAreas': 'Por Área',
  'global.text.byArea': 'Por Área',
  'global.text.areas': 'Áreas',
  'global.text.area': 'Área',
  'global.text.areaExit': 'Área Existe',
  'global.text.itemExists': 'Este elemento ya existe en la lista',
  'global.text.configuration': 'Configuración',
  'global.text.applicant': 'Solicitante',
  'global.text.select': 'Seleccione',

  'global.text.changePassword': 'Cambiar Contraseña',
  'global.text.twoFactor': 'Habilitar Two-Factor',
  'global.text.modifyView': 'Modificar Vista',
  'global.text.logout': 'Cerrar Sesión',

  'global.text.company': 'Empresa',
  'global.text.ownerCompany': 'Empresa propietaria',
  'global.text.agreement': 'Acuerdo',
  'global.text.canCreateCustomers': 'Puede crear clientes',
  'global.text.environment': 'Entorno',

  'channelEntityStatus.active': 'Activo',
  'channelEntityStatus.suspended': 'Suspendido',
  'channelEntityStatus.terminated': 'Terminado',

  'channelBillingMode.stripeAutomatic': 'Stripe automático',
  'channelBillingMode.distributorCredit': 'Crédito de distribuidor',
  'channelBillingMode.manualInvoice': 'Factura manual',

  'channelAgreementType.distributor': 'Distribuidor',
  'channelAgreementType.partner': 'Partner',
  'channelAgreementType.reseller': 'Revendedor',

  'currency.usd': 'USD',
  'global.text.search.company': 'Buscar empresa',
  'global.text.search.environment': 'Buscar entorno',
  'global.text.search.site': 'Buscar portal',

  'global.text.skip.reason': 'Motivo',
  'global.text.reject.reason': 'Motivo del Rechazo',
  'global.text.approve.reason': 'Observaciones Aprobación',
  'global.text.complete.reason': 'Observaciones Completado',
  'global.text.cancel.reason': 'Motivo de cancelación',
  'global.text.void.reason': 'Motivo de anulación',
  'global.text.delete.reason': 'Confirmar Eliminación',
  'global.text.delete.description': '¿Seguro que desea eliminar este elemento?',
  'global.text.backToAction': 'Retroceder a Acción',
  'global.text.goToAction': 'Adelantar a Acción',
  'global.text.actions': 'Acciones',
  'global.text.mapSearch': 'Buscar en mapa',
  'global.text.maps.geolocate': 'Pulse para centrar el mapa en su ubicación',
  'global.text.pin.approval.reason': 'PIN de Aprobación',

  'global.text.today': 'Hoy',
  'global.text.yesterday': 'Ayer',
  'global.text.last7Days': 'Últimos 7 días',
  'global.text.last15Days': 'Últimos 15 días',
  'global.text.last30Days': 'Últimos 30 días',
  'global.text.currentMonth': 'Mes Actual',
  'global.text.currentYear': 'Ańo Actual',
  'global.text.currentWeek': 'Semana Actual',
  'global.text.lastMonth': 'Mes Anterior',
  'global.text.last3Months': 'Últimos 3 Meses',
  'global.text.last6Months': 'Últimos 6 Meses',
  'global.text.last12Months': 'Últimos 12 Meses',
  'global.text.customRange': 'Rango Personalizado',

  'global.text.ongoingOps': 'Acciones en curso...',
  'global.text.ongoingOps.of': '{counter} de {count}',
  'global.text.configurations': 'Configuraciones',
  'global.text.void': 'Anular',

  'global.error.notAccessibleCamera':
    'La cámara esta bloqueada o no se puede acceder a ella.\n Por favor, permite la cámara en los permisos de tu navegador e inténtelo nuevamente.',
  'global.switchCamera': 'Cambiar cámara',
  'global.takePhoto': 'Tomar foto',
  'global.qr.centerCode': 'Centra el código QR dentro del marco',

  'global.message.processInstanceHasChanged':
    'El estado de la solicitud ha cambiado; ejecutando actualización!',
  'global.text.message.outOfBoundLocation':
    'La ubicación seleccionada esta fuera del area permitida',
  'global.text.message.mockLocationProvider':
    'Hemos detectado que estás utilizando una ubicación simulada. Esto no está permitido en nuestra aplicación, ya que afecta la precisión de los servicios que ofrecemos. Por favor, desactiva la simulación de ubicación y vuelve a intentarlo.',
  'global.message.securityCode': 'Código PIN de aprobación enviado satisfactoriamente',

  'global.attachment.type0': 'Desconocido',
  'global.attachment.type1': 'Imagen',
  'global.attachment.type2': 'Video',
  'global.attachment.type3': 'PDF',
  'global.attachment.type4': 'Documento Word',
  'global.attachment.type5': 'Hoja de Cálculo',
  'global.attachment.type6': 'Presentación',
  'global.attachment.type7': 'Proyecto Microsoft',
  'global.attachment.type8': 'Texto',
  'global.attachment.type9': 'Xml',
  'global.attachment.type10': 'Html',
  'global.attachment.type11': 'Json',
  'global.attachment.type12': 'Zip',
  'global.attachment.type13': 'Audio',
  'global.attachment.type14': 'Rar',
  'global.attachment.type15': 'Fuente',
  'global.attachment.type16': 'Texto Csv',

  'global.observation.type0': 'Observaciones',
  'global.observation.type1': 'Observaciones de Aprobación',
  'global.observation.type2': 'Motivo del Rechazo',

  'global.text.notValidFilePath': 'No es posible visualizar el archivo URL no válida.',
  'global.text.unsupportedFileType':
    'No es posible visualizar el archivo, tipo de archivo no soportado.',
  'global.text.form.placeholder': 'Por favor, rellene todos los campos requeridos',
  'global.text.importConfirm': '¿Desea eliminar los datos existentes?',

  'global.text.error.geolocation.failed': 'Error: El servicio de Geolocalización ha fallado.',
  'global.text.error.geolocation.support': 'Error: Su navegador no soporta Geolocalización.',
  'global.text.error.geolocation.denied': 'Error: Acceso a la localización denegado.',
  'global.text.error.video.support': 'Formato de video no soportado.',
  'global.text.error.audio.support': 'Formato de audio no soportado.',

  'global.error.title': 'Error',
  'global.error.404.title': 'Página no encontrada',
  'global.error.403.subTitle':
    'Permisos insuficientes. El usuario no tiene los permisos requeridos.',
  'global.error.404.subTitle': 'Pareces estar tratando de encontrar tu camino a casa',
  'global.error.default': 'La solicitud especificada ya no se encuentra disponible',

  'global.planType0': 'Prueba',
  'global.planType1': 'Socio',
  'global.planType2': 'Básico',
  'global.planType3': 'Negocio',
  'global.planType4': 'Empresa',
  'global.planType5': 'Personalizado',

  'global.displayText': 'Texto a mostrar',
  'global.internalName': 'Nombre interno',

  'global.field.text': 'Texto',
  'global.field.textMultiple': 'Texto Múltiple',
  'global.field.int': 'Entero',
  'global.field.int32': 'Entero',
  'global.field.decimal': 'Decimal',
  'global.field.boolean': 'Booleano',
  'global.field.dateTime': 'Fecha y Hora',
  'global.field.date': 'Fecha',
  'global.field.time': 'Hora',
  'global.field.choice': 'Selección',
  'global.field.dataBaseRemoteSearch': 'Búsqueda Remota de Base de Datos',
  'global.field.dataBaseRemoteList': 'Lista Remota de Base de Datos',
  'global.field.webServiceRemoteSearch': 'Búsqueda Remota de Servicio Web',
  'global.field.webServiceRemoteList': 'Lista Remota de Servicio Web',
  'global.field.databaseRemoteSearch': 'Búsqueda Remota de Base de Datos',
  'global.field.databaseRemoteList': 'Lista Remota de Base de Datos',
  'global.field.webserviceRemoteSearch': 'Búsqueda Remota de Servicio Web',
  'global.field.webserviceRemoteList': 'Lista Remota de Servicio Web',
  'global.field.selectorUser': 'Selector de Usuario',
  'global.field.selectorPosition': 'Selector de Puesto',
  'global.field.selectorUserGroup': 'Selector de Grupo de Usuarios',
  'global.field.table': 'Tabla',
  'global.field.attachment': 'Adjunto',
  'global.field.file': 'Archivo',
  'global.field.autoCalculatedByTableColumn': 'Calculado por Tabla',
  'global.field.fieldDynamicEntityList': 'Lista Entidad Dinamica',
  'global.field.calculatedByFormula': 'Calculado por Fórmula',
  'global.field.image': 'Imagen',
  'global.field.photo': 'Foto',
  'global.field.signature': 'Firma',
  'global.field.goToAction': 'Ir a Acción',
  'global.field.slider': 'Deslizador',
  'global.field.fieldDynamicEntitySearch': 'Búsqueda Entidad Dinamica',
  'global.field.selectorArea': 'Selector de Área',
  'global.field.radioGroup': 'Grupo de Opciones / Selección Simple',
  'global.field.checkGroup': 'Grupo de Opciones / Selección Múltiple',
  'global.field.url': 'Dirección URL',
  'global.field.location': 'Ubicación',
  'global.field.internalEntity': 'Entidad Interna',
  'global.field.intNumber': 'Número Entero',
  'global.field.decimalNumber': 'Número Decimal',
  'global.field.yesNo': 'Si/No',
  'global.field.email': 'Email',
  'global.field.password': 'Contraseña',
  'global.field.or': 'OR',
  'global.field.and': 'AND',

  'global.text.dragDrop': 'Arrastra y suelta o haz clic para reemplazar',
  'global.text.deleteData': 'Eliminar datos existentes',
  'global.text.selectFile': 'Por favor selecciona un archivo',
  'global.button.loadFile': 'Cargar Fichero',
  'global.text.auditor': 'Auditor',
  'global.text.collaborator': 'Colaborador',
  'global.text.userManager': 'Gestor de Usuarios',
  'global.text.content': 'Contenido',
  'global.error.import.data': 'Fila {rowNumber}: {errorMessage}',
  'global.error.import.multiple':
    'Se encontraron {errorCount} errores en la importación. Revisa los detalles a continuación.',
  'global.error.import.detailed':
    'Se encontraron {errorCount} errores en {rowsWithErrors} filas. {originalMessage}',
  'global.text.support': 'Soporte',
  'global.text.row': 'Fila',
  'global.text.column': 'Columna',
  'global.text.id': 'ID',
  'global.text.field': 'Campo',
  'global.text.error': 'Error',
  'global.field.ascending': 'Ascendente',
  'global.field.descending': 'Descendente',
  'global.field.none': 'No Agrupar',
  'global.field.value': 'Valor',
  'global.field.displayText': 'Texto de Visualización',
  'global.field.development': 'Desarrollo',
  'global.field.testing': 'Pruebas',
  'global.field.production': 'Producción',

  'global.text.columnOrderDirection.ascending': 'Ascendente',
  'global.text.columnOrderDirection.descending': 'Descendente',
  'global.text.responseGroupingType.none': 'Ninguno',
  'global.text.responseGroupingType.value': 'Valor',
  'global.text.responseGroupingType.displayText': 'Texto a Mostrar',

  // User Role translations
  'global.role.RoleAdmin': 'Administrador',
  'global.role.RoleSuperAdmin': 'Super Administrador',
  'global.role.RoleSupport': 'Soporte',
  'global.role.RoleUser': 'Usuario',
  'global.role.RoleCollaborator': 'Colaborador',
  'global.role.RoleAuditor': 'Auditor',
  'global.role.RoleUserManager': 'Gestor de Usuarios',
  'global.role.RolePartner': 'Socio',

  'global.profile.photo.upload.success': 'Foto de perfil actualizada correctamente',
  'global.profile.photo.upload.error': 'Error al actualizar la foto de perfil',

  // Connection error messages
  'global.error.connection.noRedirectUrl':
    'No se recibió URL de redirección del endpoint de autorización',
  'global.error.connection.noConnectionId': 'No se retornó ID de conexión de la creación',
  'global.error.connection.invalidStateFormat': 'Formato de estado inválido - se esperaba GUID',
  'global.error.connection.redirectedToAuthorization': 'Redirigido a autorización externa',

  // Password validation messages
  'global.error.password.confirmMismatch': 'Confirmar contraseña, no coincide',
  'global.error.password.sameAsCurrent': 'La contraseña nueva debe ser diferente a la actual',

  // Automy AI Chat errors
  'global.error.automyAI.noResults': 'No se encontraron resultados de Automy IA',
  'global.error.automyAI.noThreadId': 'No se encontró el ID del hilo de conversación',
  'global.error.automyAI.openChat': 'Error al abrir la conversación de Automy IA',

  // Global bulk delete translations - can be reused by any module
  'global.bulk.delete.success':
    'Se {eliminated} {successCount} {successElement} de {total} {totalElement}. Hubo {errorCount} {errorElement} que no {couldNotBeDeleted}.',
  'global.bulk.delete.error.only': 'Hubo {errorCount} {errorElement} que no {couldNotBeDeleted}.',
  'global.bulk.delete.errors.title': 'Errores de Eliminación',
  'global.errors.title': 'Errores',
  'global.import.errors.title': 'Errores de Importación',
  'global.bulk.delete.eliminated.singular': 'eliminó',
  'global.bulk.delete.eliminated.plural': 'eliminaron',
  'global.bulk.delete.element.singular': 'elemento',
  'global.bulk.delete.element.plural': 'elementos',
  'global.bulk.delete.could.not.be.deleted.singular': 'no pudo ser eliminado',
  'global.bulk.delete.could.not.be.deleted.plural': 'no pudieron ser eliminados',

  // Generic image messages for reusable components
  'global.image.upload.title': 'Subir imagen',
  'global.image.change.title': 'Cambiar imagen',
  'global.image.upload.no.file': 'Por favor selecciona una imagen primero',
  'global.image.upload.error': 'Error al procesar la imagen',
  'global.image.upload.invalid.type': 'Solo puedes subir archivos de imagen',
  'global.image.upload.invalid.size': 'La imagen debe ser menor a 5MB',
  'global.image.upload.formats': 'PNG, JPG, GIF hasta 5MB',
  'global.image.rotate.left': 'Rotar a la izquierda',
  'global.image.rotate.right': 'Rotar a la derecha',
  'global.image.drag.instruction': 'Arrastra la imagen para ajustar la vista previa',
  'global.image.select.different': 'Seleccionar otra imagen',

  // Date formats
  'global.date.format': 'DD/MM/YYYY',

  // HTTP Response Status Codes
  'global.httpResponseStatusCode.100': 'Continuar',
  'global.httpResponseStatusCode.101': 'Cambio de Protocolos',
  'global.httpResponseStatusCode.200': 'OK',
  'global.httpResponseStatusCode.201': 'Creado',
  'global.httpResponseStatusCode.202': 'Aceptado',
  'global.httpResponseStatusCode.203': 'Información No Autoritativa',
  'global.httpResponseStatusCode.204': 'Sin Contenido',
  'global.httpResponseStatusCode.205': 'Restablecer Contenido',
  'global.httpResponseStatusCode.206': 'Contenido Parcial',
  'global.httpResponseStatusCode.300': 'Múltiples Opciones',
  'global.httpResponseStatusCode.301': 'Movido Permanentemente',
  'global.httpResponseStatusCode.302': 'Encontrado',
  'global.httpResponseStatusCode.303': 'Ver Otro',
  'global.httpResponseStatusCode.304': 'No Modificado',
  'global.httpResponseStatusCode.305': 'Usar Proxy',
  'global.httpResponseStatusCode.306': 'No Utilizado',
  'global.httpResponseStatusCode.307': 'Redirección Temporal',
  'global.httpResponseStatusCode.400': 'Solicitud Incorrecta',
  'global.httpResponseStatusCode.401': 'No Autorizado',
  'global.httpResponseStatusCode.402': 'Pago Requerido',
  'global.httpResponseStatusCode.403': 'Prohibido',
  'global.httpResponseStatusCode.404': 'No Encontrado',
  'global.httpResponseStatusCode.405': 'Método No Permitido',
  'global.httpResponseStatusCode.406': 'No Aceptable',
  'global.httpResponseStatusCode.407': 'Autenticación de Proxy Requerida',
  'global.httpResponseStatusCode.408': 'Tiempo de Solicitud Agotado',
  'global.httpResponseStatusCode.409': 'Conflicto',
  'global.httpResponseStatusCode.410': 'Desaparecido',
  'global.httpResponseStatusCode.411': 'Longitud Requerida',
  'global.httpResponseStatusCode.412': 'Precondición Fallida',
  'global.httpResponseStatusCode.413': 'Entidad de Solicitud Demasiado Grande',
  'global.httpResponseStatusCode.414': 'URI de Solicitud Demasiado Larga',
  'global.httpResponseStatusCode.415': 'Tipo de Medio No Soportado',
  'global.httpResponseStatusCode.416': 'Rango Solicitado No Satisfactorio',
  'global.httpResponseStatusCode.417': 'Expectativa Fallida',
  'global.httpResponseStatusCode.426': 'Actualización Requerida',
  'global.httpResponseStatusCode.500': 'Error Interno del Servidor',
  'global.httpResponseStatusCode.501': 'No Implementado',
  'global.httpResponseStatusCode.502': 'Puerta de Enlace Incorrecta',
  'global.httpResponseStatusCode.503': 'Servicio No Disponible',
  'global.httpResponseStatusCode.504': 'Tiempo de Puerta de Enlace Agotado',
  'global.httpResponseStatusCode.505': 'Versión HTTP No Soportada',

  // RunCode Operation Status
  'global.runCodeOperationStatus.1': 'Pendiente',
  'global.runCodeOperationStatus.2': 'Instalando',
  'global.runCodeOperationStatus.3': 'Ejecutando',
  'global.runCodeOperationStatus.4': 'Completado',
  'global.runCodeOperationStatus.5': 'Fallido',
  'global.runCodeOperationStatus.6': 'Expirado',
  'global.runCodeOperationStatus.7': 'Error',
  'global.runCodeOperationStatus.8': 'No Encontrado',

  // Process Config
  'process.config.version': 'Versión',
  'process.config.versionSelectorDisabled':
    'El selector de versiones estará disponible próximamente',

  'global.text.column.extraSmall': 'Extra Pequeño',
  'global.text.column.small': 'Pequeño',
  'global.text.column.medium': 'Mediano',
  'global.text.column.large': 'Grande',

  'global.dynamicEntityVersionOperation.1': 'Generar Token de Lectura',
  'global.dynamicEntityVersionOperation.2': 'Generar Token de Escritura',
  'global.dynamicEntityVersionOperation.3': 'Adicionar Componente',
  'global.dynamicEntityVersionOperation.4': 'Actualizar Componente',
  'global.dynamicEntityVersionOperation.5': 'Eliminar Componente',
  'global.dynamicEntityVersionOperation.6': 'Publicar',
  'global.dynamicEntityVersionOperation.7': 'Nueva Version Creada',

  'global.userDisplayValue.full-name': 'Nombre Completo',
  'global.userDisplayValue.email': 'Correo Electrónico',
  'global.userDisplayValue.extra-field': 'Campo Extra',
  'global.userDisplayValue.position': 'Posición',
  'global.userDisplayValue.area': 'Area',

  'global.internalTaskStatus.type1': 'Pendiente',
  'global.internalTaskStatus.type2': 'Procesando',
  'global.internalTaskStatus.type3': 'Procesada',
  'global.internalTaskStatus.type4': 'Error',
  'global.internalTaskStatus.type5': 'Omitida',
  'global.internalTaskStatus.type6': 'Cancelada',
  'global.internalTaskStatus.type7': 'Fallida',

  // Clipbord
  'global.clipboard.copied': 'Copiado al portapapeles',
  'global.clipboard.error': 'Error al copiar al portapapeles',

  'actions.type.default': 'Acción del proceso',
  'actions.type.defaultInitial': 'Predeterminado',
  'actions.type.completeInformation': 'Completar Información',
  'actions.type.approval': 'Aprobación',
  'actions.type.autoApprove': 'Aprobación Automática',
  'actions.type.conditional': 'Condicional',
  'actions.type.executeTask': 'Ejecutar Tarea',
  'actions.type.executeApiCall': 'Ejecutar Llamada API',
  'actions.type.autoReject': 'Rechazo Automático',
  'actions.type.digitalSignature': 'Firma Digital',
  'actions.type.sendEmail': 'Enviar Correo',
  'actions.type.executeQuery': 'Ejecutar Consulta de Base de Datos',
  'actions.type.dynamicEntityOperation': 'Operación sobre Entidad Dinámica',
  'actions.type.generateExcel': 'Generar Excel',
  'actions.type.startProcessInstance': 'Iniciar Proceso',
  'actions.type.setVariableData': 'Establecer Variable',
  'actions.type.setFormData': 'Establecer Datos de Formulario',
  'actions.type.parallel': 'Paralelo',
  'actions.type.generateDocuments': 'Generar Documentos',
  'actions.type.scheduledExecution': 'Ejecución Programada',
  'actions.type.sharePointOperation': 'Operación en SharePoint',
  'actions.type.iterate': 'Iterar / Aplicar a cada uno',
  'actions.type.switch': 'Switch',
  'actions.type.internalOperation': 'Operación Interna',
  'actions.type.generatePlainTextFile': 'Generar Fichero Texto',
  'actions.type.importPlainTextFile': 'Importar Archivo de Texto sin Formato',
  'actions.type.consumeSequence': 'Consumir Secuencia',
  'actions.type.executeRpaFlow': 'Ejecutar Flujo RPA',
  'actions.type.integration': 'Integración',
  'actions.type.autoCancel': 'Cancelar Automático',
  'actions.type.autoVoid': 'Anular Automático',
  'actions.type.openAi': 'Open AI',
  'actions.type.executeProcessAction': 'Ejecutar Acción Proceso',
  'actions.type.googleIntegration': 'Integración Google',
  'actions.type.revertCancellation': 'Revertir Cancelación',
  'actions.type.revertVoiding': 'Revertir Anulación',
  'actions.type.ftpOperation': 'Operación FTP',
  'actions.type.runCode': 'Ejecutar Código',
  'actions.type.automyAi': 'Automy IA',
  'actions.type.whatsAppBusinessIntegration': 'Integración WhatsApp Business',
  'actions.type.microsoftTeamsIntegration': 'Integración Microsoft Teams',

  'accessPolicy.effect.allow': 'Permitir',
  'accessPolicy.effect.deny': 'Denegar',

  'global.text.number': 'Número',
  'global.text.operationType': 'Tipo de Operación',
  'global.text.observations': 'Observaciones',
  'global.text.processingDate': 'Fecha de Procesamiento',
  'global.text.processedDate': 'Fecha de Procesado',
  'global.text.processingAttempts': 'Intentos de Procesamiento',
  'global.text.scheduledDate': 'Fecha Programada',
  'global.text.taskParameters': 'Parámetros de tarea',
  'global.text.alertEmails': 'Correos de alerta',
  'global.text.lastProcessingHeartbeat': 'Último heartbeat de procesamiento',
  'global.text.processingNodeId': 'ID nodo de procesamiento',
  'global.text.processingNodeName': 'Nombre nodo de procesamiento',
  'global.text.dependsOnTaskNumber': 'Tarea dependiente',

  'internalTaskStatus.pending': 'Pendiente',
  'internalTaskStatus.processing': 'Procesando',
  'internalTaskStatus.processed': 'Procesado',
  'internalTaskStatus.error': 'Error',
  'internalTaskStatus.skipped': 'Omitido',
  'internalTaskStatus.cancelled': 'Cancelado',
  'internalTaskStatus.failed': 'Fallido',
  'internalTaskStatus.unknown': 'Desconocido',
};
